import React, { useCallback } from 'react';

import { StyledAuthTypeSelector, AuthTypeSelectorButton } from './styles';

export interface AuthTypeSelectorProps {
  authType: 'email' | 'phone';
  setAuthType: (authType: 'email' | 'phone') => void;
}

export const AuthTypeSelector: React.FC<AuthTypeSelectorProps> = ({
  authType,
  setAuthType,
}) => {
  const onSetEmail = useCallback(() => {
    setAuthType('email');
  }, []);

  const onSetPhone = useCallback(() => {
    setAuthType('phone');
  }, []);

  return (
    <StyledAuthTypeSelector>
      <AuthTypeSelectorButton
        type="button"
        isSelected={!authType || authType === 'email'}
        onClick={onSetEmail}
      >
        Email
      </AuthTypeSelectorButton>
      <AuthTypeSelectorButton
        type="button"
        isSelected={authType === 'phone'}
        onClick={onSetPhone}
      >
        Phone
      </AuthTypeSelectorButton>
    </StyledAuthTypeSelector>
  );
};
